const editList = require('../editList/editList');

const editList_table = Object.assign({}, editList, {
    subelements: {
        listItemsHolder: false,
        deleteWarning: false,
        searchInput: false,
        searchClear: false,
        searchIcon: false,
        searchClearIcon: false,
        table: false,
        toggleHiddenRows: false,
    },
    // The table tpl emits no data-zit-enable-add/-remove, so mirror the PHP class
    // (which hard-forces both off) instead of inheriting editList's true defaults —
    // enableAdd also gates the listItem template fetch in editList.init.
    enableAdd: false,
    enableRemove: false,
    hiddenRowsVisible: false,
    showRowsButtonText: '',

    init: function () {
        editList.init.call(this);

        if (this.subelements.toggleHiddenRows !== false) {
            this.showRowsButtonText = this.subelements.toggleHiddenRows.innerHTML.trim();
            this.subelements.toggleHiddenRows.addEventListener('click', (e) => { e.preventDefault(); this.toggleRows(); });
        }
    },

    toggleRows: function () {
        // Use querySelectorAll (NodeList has forEach; HTMLCollection from .rows does not)
        this.subelements.table.querySelectorAll('tbody tr').forEach((row) => {
            // zit-hook-show-more-row: JS-only marker added in editList_table.tpl on rows
            // past the visible limit; never carries styling/theme classes (see
            // scripts/behaviors.contract.md "JS hook / selector classes").
            if (row.classList.contains('zit-hook-show-more-row')) {
                if (this.hiddenRowsVisible) {
                    this.hm.helper.hideElement(row);
                } else {
                    this.hm.helper.showElement(row);
                }
            }
        });

        if (this.hiddenRowsVisible) {
            this.subelements.toggleHiddenRows.innerHTML = this.showRowsButtonText;
        } else {
            this.subelements.toggleHiddenRows.innerHTML = this.hm.app.utext('showLess');
        }
        this.hiddenRowsVisible = !this.hiddenRowsVisible;
    },

    doSearch: function () {
        editList.doSearch.call(this);

        let searchActive = this.subelements.searchInput.value.trim().length > 0;

        // An active search overrides the rows limit: a matching row must be visible
        // even past rowsLimit (base doSearch never reveals rows it didn't hide), and
        // clearing the query restores the show-more state.
        this.listItems.forEach((listItem) => {
            if (listItem.element.classList.contains('zit-hook-show-more-row')) {
                if (searchActive) {
                    if (!listItem.searchHidden) {
                        this.hm.helper.showElement(listItem.element);
                    }
                } else if (!this.hiddenRowsVisible) {
                    this.hm.helper.hideElement(listItem.element);
                }
            }
        });

        if (this.subelements.toggleHiddenRows !== false) {
            this.hm.helper.showElement(this.subelements.toggleHiddenRows, !searchActive);
        }
    }
});

module.exports = editList_table;
